export const getDaysArray = () => {
    const array = []
    const daysCount = 31

    for (let day = 1; day <= daysCount; day++) {
        day.toString().length === 1
            ? array.push({ value: `0${day}`, label: `0${day}` })
            : array.push({ value: `${day}`, label: `${day}` })
    }

    return array
}
